import { Transactions } from '~/biz/store/transactions/types'
import { Moment } from '~/types'

export enum XFERS_ACCEPT_TAB_KEY {
  VIRTUAL_ACCOUNTS = 'virtual_accounts',
  QRIS = 'qris',
  E_WALLET = 'e_wallet',
  RETAIL = 'retail',
  CASHIN = 'cashin',
}

export type IndoTransactions = Transactions & {
  completed_at: string | null
  fee?: string | undefined
  net_amount: {
    prefix: string
    postfix: string
  }
  wallet_type: string
  source_destination: {
    source: string
    destination: string
  }
  merchant_description: string
}

export type FilterOptions = {
  transactionStatuses: Array<{ label: string; value: string }>
  sortTypes: Array<{ label: string; value: string }>
  paymentChannels: Array<{ label: string; value: string }> | undefined
  banks: Array<{ abbreviation: string; bankName: string; value: string }> | undefined
}

export type FilterValuesObject = {
  [filterKey: string]:
    | Moment
    | string[]
    | number[]
    | string
    | number
    | IndoTransactions[]
    | boolean
    | undefined
}

export type FilterValues = {
  startDate: Moment | string
  endDate: Moment | string
  transactionStatuses: string[]
  paymentMethod: string
  sortType: string
  accountIds: number[]
  currentPage: number
  pageLimit: number
  searchString: string
  contractsExist: boolean
  banks: string[]
  paymentChannels: string[]
  isTransactionLoading: boolean
  transactions: IndoTransactions[]
  [key: string]: FilterValuesObject[keyof FilterValuesObject]
}

export enum ID_TRANSACTIONS_ACTIONS {
  SET_IS_TRANSACTION_LOADING = 'ID_TRANSACTIONS_ACTIONS.SET_IS_TRANSACTION_LOADING',
  SET_FILTERS = 'ID_TRANSACTION_ACTIONS.SET_FILTERS',
  SET_IS_FILTER_LOADING = 'ID_TRANSACTION_ACTIONS.SET_IS_FILTER_LOADING',
  GET_TRANSACTIONS = 'ID_TRANSACTIONS_ACTIONS.GET_TRANSACTIONS',
  GET_TRANSACTIONS_FILTER_OPTIONS = 'ID_TRANSACTION_ACTIONS.GET_TRANSACTIONS_FILTER_OPTIONS',
  SET_TRANSACTIONS_FILTER_OPTIONS_LOADING = 'ID_TRANSACTION_ACTIONS.SET_TRANSACTION_FILTER_OPTIONS_LOADING',
  SET_TRANSACTIONS_ERROR_MESSAGE = 'ID_TRANSACTIONS_ACTIONS.SET_TRANSACTIONS_ERROR_MESSAGE',
  SET_TAB_KEY_NAME = 'ID_TRANSACTIONS_ACTIONS.SET_TAB_KEY_NAME',
}

type SetIsTransactionLoading = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_IS_TRANSACTION_LOADING
  isTransactionLoading: boolean
}

type SetIsFilterLoading = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_IS_FILTER_LOADING
  isFilterLoading: boolean
}

type GetTransactions = {
  type: typeof ID_TRANSACTIONS_ACTIONS.GET_TRANSACTIONS
  transactions: IndoTransactions[]
  contractsExist: boolean
}

type GetTransactionsFilterOptions = {
  type: typeof ID_TRANSACTIONS_ACTIONS.GET_TRANSACTIONS_FILTER_OPTIONS
  filterOptions: FilterOptions
}

type SetTransactionsFilterOptions = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_TRANSACTIONS_FILTER_OPTIONS_LOADING
  isFilterOptionsLoading: boolean
}

type SetFilters = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_FILTERS
  filterValuesObject: FilterValuesObject
}

type SetTransactionsErrorMessage = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_TRANSACTIONS_ERROR_MESSAGE
  errorMessage: string
}

type SetTabKeyName = {
  type: typeof ID_TRANSACTIONS_ACTIONS.SET_TAB_KEY_NAME
  tabKeyName: string
}

export type ActionTypes =
  | SetIsTransactionLoading
  | SetIsFilterLoading
  | GetTransactions
  | GetTransactionsFilterOptions
  | SetTransactionsFilterOptions
  | SetFilters
  | SetTransactionsErrorMessage
  | SetTabKeyName
